import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { APP_ROUTES } from '@app/constants';
import { AuthService } from '@app/core/auth';

@Component({
  selector: 'app-logout',

  imports: [],
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.css',
})
export class LogoutComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit(): void {
    if (this.authService.isAuthenticated()) {
      this.authService.logout().subscribe({
        next: () => {
          this.router.navigate([APP_ROUTES.LOGIN]).then();
        },
        error: () => {
          this.router.navigate([APP_ROUTES.LOGIN]).then();
        }
      });
    } else {
      this.router.navigate([APP_ROUTES.LOGIN]).then();
    }
  }
}
